<template>
  <div v-show='cpntMostrar' class="rf-input-group" :class='cpntClassDivField'>
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='status !== ""'>
      <RF-Status :cpntStatus='status' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <input v-if="$store.state.mobile === true"
        type="date"
        :value="value" 
        :config='cpntConfig' 
        :inputClass='classCampo'
        :tabIndex='cpntTabIndex'
        :disabled='cpntDisabled'
        placement="bottom-right"

        @change='onChange'
        @dp-show='cpntDatePickerOnShow'
        @dp-hide='cpntDatePickerOnHide'
        :ref="cpntId"/>

      <date-picker v-else
        :value="value" 
        :config='cpntConfig' 
        :inputClass='classCampo'
        :tabIndex='cpntTabIndex'
        :disabled='cpntDisabled'
        placement="bottom-right"

        @dp-change='onChange'
        @dp-show='cpntDatePickerOnShow'
        :ref="cpntId"
      ></date-picker>
        <!-- @dp-hide='cpntDatePickerOnHide' -->

      <span class="rf-barra"></span>
      <label :for='cpntId' :class='"has-" + cpntMensagemTipo'>
        <span v-html='cpntNome'></span>

        <RF-Explica v-if='[ "", null, undefined ].indexOf(cpntExplica) === -1 && Object.keys(cpntExplica).length >= 1'
          :cpntId='cpntId + "-explica"' 
          :cpntTitle='cpntExplica.mensagem'
          :cpntPositionMy='cpntExplica.posicaoMy'
          :cpntPositionAt='cpntExplica.posicaoAt'
          :cpntClasses='cpntExplica.class'

          style='vertical-align: 0px;'
        ></RF-Explica>
      </label>
      <span v-if='cpntMensagem !== "" && cpntMensagem !== null' v-html='cpntMensagem' :class='"has-" + cpntMensagemTipo'></span>
    </template>
  </div>
</template>

<style scoped>
/* -=-=-=-=-=-= ESTILO INICIAL =-=-=-=-=-=- */
.rf-input-group {
  position: relative;
  margin-bottom: 30px;
}

/* ------------------ CONFIGURA O INPUT ------------------ */
.rf-input-group > input {
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #CCC;
  padding: 5px 5px 5px 5px;
  color: #292b2c;
 }
  /* ------------------ REMOVE BORDAS INPUT QUANDO DA FOCUS ------------------ */
  .rf-input-group > input:focus { 
    outline: none; 
  }

/* ------------------ MODO DE ABERTURA DA ANIMAÇÃO ------------------ */
.rf-input-group > input:focus ~ .rf-barra:before, .rf-input-group > input:focus ~ .rf-barra:after {
  width: 50%;
}
.rf-barra:before { 
  left: 50%;
}
.rf-barra:after {
  right: 50%;
}
/* ------------------ APRESENTA A BARRA ABAIXO DO INPUT QUANDO SELECIONADO ------------------ */
.rf-barra {
  position: relative;
  display: block;
  width: 100%;
 }
.rf-barra:before, .rf-barra:after {
  position: absolute;
  bottom: 1px;
  content: '';
  width: 0px;
  height: 2px;
  background: #4285f4;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
 }
/* ------------------ TITULO DO CAMPO ------------------ */
.rf-input-group > label {
  position: absolute;
  left: 0px;
  top: -20px;
  color: var(--color-base-02);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
 }   
  /* ------------------ LOCAL E COR QUE FICA O TITULO DO CAMPO APÓS PREENCHIDO ------------------ */
  .rf-input-group > input:focus ~ label, .rf-input-group > input.rf-input-focus-true ~ label {
    top: -20px;
  }
  .rf-input-group > input:focus ~ label {
    color: #4285f4;
  }
  /* ------------------ ALTERA A COR CASO NÃO SEJA VALIDADO ------------------ */
    .rf-input-group > input.has-error ~ label {
      top: -20px;
      color: #a94442;
    }
    .rf-input-group > input.has-error ~ .rf-barra:before, .rf-input-group > input.has-error ~ .rf-barra:after {
      position: absolute;
      bottom: 1px;
      content: '';
      width: 0px;
      height: 2px;
      background: #a94442;
      transition: 0.2s ease all;
      -moz-transition: 0.2s ease all;
      -webkit-transition: 0.2s ease all;
      width: 50%;
    }

    .rf-input-group > input:disabled {
      background: #fff;
      color: rgba(0, 0, 0, 0.65);
      cursor: not-allowed;
    }

  .rf-input-group > input.form-control {
    border-top: none;
    border-left: none;
    border-right: none;

    box-shadow: none;
  }
</style>

<script>
  // Import required dependencies
  import 'bootstrap/dist/css/bootstrap.css'

  // Import this component
  import datePicker from 'vue-bootstrap-datetimepicker'

  // Import date picker css
  import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'

  // IMPORTA BIBLIOTECA DEPENDENTE
  var moment = require('moment')

  export default {
    name: 'RF-Input-Calendario',
    components: {
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      'date-picker': datePicker
    },
    props: {
      cpntStatus: {
        required: true
      },
      cpntId: {
        required: true,
        type: String
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntValue: {
        default: null,
        required: true,
        validator: function (value) {
          return value === null || value instanceof Date || typeof value === 'string' || value instanceof String
        }
      },
      cpntMask: {
        required: false,
        type: String,
        validator: function (val) {
          return ([ null, 'valor' ].indexOf(val) !== -1)
        },
        default: function () {
          return null
        }
      },
      cpntAutoComplete: {
        type: String,
        required: false,
        default: 'off'
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntAutoFocus: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntPlaceholder: {
        type: String,
        required: false,
        default: ''
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },
      cpntConfig: {
        required: false,
        type: Object,
        default: function () {
          return {
            format: 'DD/MM/YYYY',
            locale: 'pt-br'
          }
        }
      },
      cpntPosicionar: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntClassDivField: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return []
        }
      },
      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        status: '',
        value: null,
        classCampo: '',
        mask: ''
      }
    },
    mounted: function () {
      this.iniciarCampo()
    },
    methods: {
      iniciarCampo: function () {
        // SETA O STATUS
        this.status = 'carregando'

        // RESETA AS CLASSES DO INPUT
        this.classCampo = ''

        // PEGA O VALOR RECEBIDO
        var valor = this.cpntValue === '' ? null : this.cpntValue
        
        // VERIFICA SE TEM QUE CONVERTER O VALOR
        if (this.$store.state.mobile === true && [ '', null, undefined ].indexOf(valor) === -1) {
          // PEGA DATA SOLICITADA 
          valor = moment(valor, 'DD/MM/YYYY')

          // CONVERTE O VALOR RECEBIDO
          valor = valor.format('YYYY-MM-DD')
        }

        // SETA O VALOR DO CALENDARIO
        this.value = valor

        // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
        this.checarClassCampo()

        // ALTERA O STATUS
        this.status = ''
      },
      checarClassCampo: function () {
        var inputclass = this.classCampo.split(' ')

        // REMOVE AS CLASSES DE FOCUS
        inputclass = inputclass.filter(item => (item !== 'rf-input-focus-true' && item !== 'rf-input-focus-false'))

        // VERIFICA SE O VALOR FOI PREENCHIDO
        if (this.value !== '') {
          inputclass.push('rf-input-focus-true')
        } else {
          inputclass.push('rf-input-focus-false')
        }

        inputclass = inputclass.join(' ')

        this.classCampo = inputclass
      },
      onChangeValue: function (value) {
        if (this.cpntValue.toString() !== value.toString()) {
          if (this.cpntOnChange !== null) {
            this.cpntOnChange(value, this.cpntId)
          }
        }

        // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
        this.checarClassCampo()
      },
      onChange: function (event) {
        if (this.$store.state.mobile === true) {
          // PEGA A DATA RECEBIDA
          var data = JSON.parse(JSON.stringify(event.target.value))

          // CHAMA A FUNÇÃO PARA ATUALIZAR A DATA
          this.onChangeValue(moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        } else if (event.date === false) {
          this.onChangeValue('')
        } else if (this.cpntConfig.hasOwnProperty('format') && this.cpntConfig.format === 'DD/MM/YYYY HH:mm') {
          this.onChangeValue(moment(event.date['_d']).format('DD/MM/YYYY HH:mm:ss'))
        } else {
          this.onChangeValue(moment(event.date['_d']).format('DD/MM/YYYY'))
        }
      },
      onFocusField: function () {
        this.$store.state.mobile === false ? this.$refs[this.cpntId].$el.select() : this.$refs[this.cpntId].click()
      },
      // cpntDatePickerOnHide: function () {
      //   if (this.cpntPosicionar === true) {
      //     // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
      //     const FUN_MOSTRAR_SCROLL_BODY = require('@/assets/js/Funcoes-Gerais.js').FUN_MOSTRAR_SCROLL_BODY
  
      //     // SETA SE DEVE ATIVAR O SROLL DO BODY OU NÃO
      //     FUN_MOSTRAR_SCROLL_BODY(true)
      //   }
      // },
      cpntDatePickerOnShow: function (event) {
        if (this.cpntPosicionar === true) {
          // // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
          // const FUN_MOSTRAR_SCROLL_BODY = require('@/assets/js/Funcoes-Gerais.js').FUN_MOSTRAR_SCROLL_BODY

          // // SETA SE DEVE ATIVAR O SROLL DO BODY OU NÃO
          // FUN_MOSTRAR_SCROLL_BODY(false)

          // PEGA O INPUT RECEBIDO
          var target = event.target
  
          // PEGA A DIV DO CALENDARIO
          var calendario = $(target).parent().find('.bootstrap-datetimepicker-widget')[0]
  
          // PEGA OS PARAMETROS
          var paramsInput = target.getBoundingClientRect()
          var paramsCalendario = calendario.getBoundingClientRect()

          // VERIFICA AONDE DEVE POSICIONAR O CALENDARIO
          switch ((paramsInput.top + paramsInput.height) >= paramsCalendario.height) {
            case false:
              $(calendario).css({ height: '250px', position: 'fixed', top: (paramsInput.top + paramsInput.height), left: (paramsInput.left + 'px') })
              break

            case true:
              $(calendario).css({ height: '250px', position: 'fixed', top: (paramsInput.top - ((paramsInput.height / 3) + paramsCalendario.height)), left: (paramsInput.left + 'px') })
              break
          }
        }
      }
    },
    beforeDestroy: function () {
      // Free up memory
      if (this.dp) {
        this.dp.destroy()
        this.dp = null
        this.elem = null
      }
    },
    watch: {
      'cpntValue': function () {
        if (this.cpntValue !== this.value) {
          // PEGA O VALOR RECEBIDO
          var valor = this.cpntValue === '' ? null : this.cpntValue
          
          // VERIFICA SE TEM QUE CONVERTER O VALOR
          if (this.$store.state.mobile === true && [ '', null, undefined ].indexOf(valor) === -1) {
            // PEGA DATA SOLICITADA 
            valor = moment(valor, 'DD/MM/YYYY')

            // CONVERTE O VALOR RECEBIDO
            valor = valor.format('YYYY-MM-DD')
          }

          // SETA O VALOR DO INPU
          this.value = valor

          // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
          this.checarClassCampo()
        }
      },
      'cpntFocus': function () {
        if (this.cpntFocus !== '') {
          if (this.cpntId === this.cpntFocus) {
            this.$el.children[0].focus()

            this.$emit('onLimpaFormularioFocus')
          }
        }
      }
    }
  }
</script>
